import { MenuBookGroupInfoType } from 'apis/types';

export function checkMenuBookCanShow(currentTimeFrame: string, menubookItem: MenuBookGroupInfoType): boolean {
  return !menubookItem.course && menubookItem.time_frame_id
    ? menubookItem.time_frame_id.includes(currentTimeFrame)
    : true;
}
